//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BScroll from "better-scroll"
import Titles from '@/components/titles'
export default {
    components: {
        Titles
    },
    data() {
        return {
            lodeMoreMessage: "点击加载更多",
            userReviews: [],
            page: 0
        }
    },
    mounted() {
        this.loadMoreComments()
    },
    
    methods: {
        userReviewShow(item){
            let unshowList = [1,206509,243744,203241,272562,271694]
            if(unshowList.indexOf(item.uid) > 0 && item.content!=''){
                return false
            }else{
                return true
            }
        },
        toQuestion(queryId) {
            this.$router.push({ path: `/query/queryDetail`, query: { id: queryId } })
        },
        loadMoreComments() {
            if (this.lodeMoreMessage !== "暂无更多评论") {
                this.lodeMoreMessage = "加载中..."
                this.$http
                    .get(
                        `${this.$store.state.origin}/api/query/v2/queryrate/qr?p=${this
                            .page + 1}`
                    )
                    .then(
                        res => {
                            if (res.body.result) {
                                this.lodeMoreMessage = "点击加载更多"
                                res.body.result.map((item, i) => {
                                    if (item.tag) {
                                        item.tag = item.tag.split(",")
                                    }
                                    this.userReviews.push(item)
                                })
                                this.page += 1
                            } else {
                                this.lodeMoreMessage = "暂无更多评论"
                            }
                        },
                        err => {
                            console.log(err)
                        }
                    )
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/userEvaluate.vue